import { hasAppAccess } from '@/lib/access'
// ** Entity Imports
import { useGetCurrentUserQuery } from '@/entities/user'

// ** React Imports
import { useEffect } from 'react'

// ** Third Party Imports
import { useNavigate } from 'react-router-dom'

export const Redirect = () => {
	const navigate = useNavigate()
	const { data: currentUser, isLoading } = useGetCurrentUserQuery()

	// redirect to the appropriate page based on the user's subscription status after login
	useEffect(() => {
		if (!isLoading && currentUser) {
			if (hasAppAccess(currentUser)) {
				navigate('/client-dashboard', { replace: true })
				if (
					currentUser.role?.name === 'Owner' &&
					currentUser.showSubscriptionModal
				) {
					navigate('/subscription-confirmation', { replace: true })
				}
			}
			// else {
			// 	const path =
			// 		currentUser.organization.isFormSubmitted ||
			// 		currentUser.organization.isFormSkiped
			// 			? '/client-dashboard'
			// 			: '/schedule'

			// 	navigate(path, { replace: true })
			// }
		}
	}, [currentUser, isLoading, navigate])

	return null
}
